import axiosInstance from "@/api/axios-instance";

export async function extendBundleValidity({
  usage_id,
  end_date,
}: {
  usage_id: string;
  end_date: string;
}) {
  const response = await axiosInstance.patch("/usage", {
    usage_id,
    end_date,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("failed extending bundle validity");
  }

  const data = response.data;
  return data;
}
